import { render, staticRenderFns } from "./FFOtpComponent.vue?vue&type=template&id=2ed8e3b8&scoped=true"
import script from "./FFOtpComponent.vue?vue&type=script&lang=js"
export * from "./FFOtpComponent.vue?vue&type=script&lang=js"
import style0 from "./FFOtpComponent.vue?vue&type=style&index=0&id=2ed8e3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8e3b8",
  null
  
)

export default component.exports